export default __webpack_public_path__ + "static/media/water-tap.498f1767.png";